import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form } from 'react-bootstrap';
import SecurityQuestion from '../SecurityQuestion';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useNavigate } from 'react-router-dom';
import { setHasSecurityQuestions } from '../../../../redux/app/userSlice';
import CookiesService from '../../../shared/CookiesService';
import { ToastContainer, toast } from 'react-toastify';
import ToastMessage from '../../common/ToastMessage';
import { HorizontalDivider } from 'src/Admin/components/common/HorizontalDivider';
import { axiosInstance } from '../../../../api/axios';
import { HttpSuccessCodes } from '../../../errorhandling/HttpErrorCodes';
import CustomClientError from '../../../errorhandling/CustomClientError';
import APIEndpoints from '../../../api/APIEndpoints';
import * as yup from 'yup';
import './securityquestions.scss';

const SecurityQuestionsPanel = () => {
  const ErrorMessage = ({ message }) => (
    <ToastMessage type="error" title="Security Question" subTitle={message} />
  );
  const formFields = {
    Oid: CookiesService.get('Oid'),
    securityQuestionDetails: '',
    othersOid: '',
    email: CookiesService.get('UserID'),
  };
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLoggedIn } = useSelector(({ user }) => user);
  const [selectedQuestionValues, setSelectedQuestionValues] = useState([
    null,
    null,
    null,
  ]);
  const [isButtonDisable, setIsButtonDisable] = useState(true);
  const [userData, setUserData] = useState(formFields);
  const [securitysQuestionsError, setSecuritysQuestionsError] = useState(false);
  const [saveSecurityQAError, setSaveSecurityQAError] = useState(false);

  const securityQuestionschema = yup.object({
    question1: yup
      .object()
      .required('Question selection is required')
      .nullable(),
    question2: yup
      .object()
      .required('Question selection is required')
      .nullable(),
    question3: yup
      .object()
      .required('Question selection is required')
      .nullable(),
    answer1: yup
      .string()
      .required('Answer is required')
      .min(4, 'Answer must be at least 4 characters')
      .max(128, 'Answer must not exceed 128 characters')
      .test(
        'Checking answer 1 and 2',
        'Answer should not be same',
        function (value) {
          return value ? value !== this.parent.answer2 : true;
        },
      )
      .test(
        'Checking answer 1 and 3',
        'Answer should not be same',
        function (value) {
          return value ? value !== this.parent.answer3 : true;
        },
      ),
    answer2: yup
      .string()
      .required('Answer is required')
      .min(4, 'Answer must be at least 4 characters')
      .max(128, 'Answer must not exceed 128 characters')
      .test(
        'Checking answer 2 and 1',
        'Answer should not be same',
        function (value) {
          return value ? value !== this.parent.answer1 : true;
        },
      )
      .test(
        'Checking answer 2 and 3',
        'Answer should not be same',
        function (value) {
          return value ? value !== this.parent.answer3 : true;
        },
      ),
    answer3: yup
      .string()
      .required('Answer is required')
      .min(4, 'Answer must be at least 4 characters')
      .max(128, 'Answer must not exceed 128 characters')
      .test(
        'Checking answer 3 and 1',
        'Answer should not be same',
        function (value) {
          return value ? value !== this.parent.answer1 : true;
        },
      )
      .test(
        'Checking answer 3 and 2',
        'Answer should not be same',
        function (value) {
          return value ? value !== this.parent.answer2 : true;
        },
      ),
    customQuestion1: yup.string().when('question1', {
      is: (question1) => question1 && question1.value === 'Others',
      then: () =>
        yup
          .string()
          .required('Question is required')
          .min(10, 'Question must be at least 10 characters')
          .max(256, 'Question must not exceed 256 characters')
          .test(
            'Checking Custom Question 1 and 2',
            'Question should not be same',
            function (value) {
              return value ? value !== this.parent.customQuestion2 : true;
            },
          )
          .test(
            'Checking Custom Question 1 and 3',
            'Question should not be same',
            function (value) {
              return value ? value !== this.parent.customQuestion3 : true;
            },
          ),
    }),
    customQuestion2: yup.string().when('question2', {
      is: (question2) => question2 && question2.value === 'Others',
      then: () =>
        yup
          .string()
          .required('Question is required')
          .min(10, 'Question must be at least 10 characters')
          .max(256, 'Question must not exceed 256 characters')
          .test(
            'Checking Custom Question 2 and 1',
            'Question should not be same',
            function (value) {
              return value ? value !== this.parent.customQuestion1 : true;
            },
          )
          .test(
            'Checking Custom Question 2 and 3',
            'Question should not be same',
            function (value) {
              return value ? value !== this.parent.customQuestion3 : true;
            },
          ),
    }),
    customQuestion3: yup.string().when('question3', {
      is: (question3) => question3 && question3.value === 'Others',
      then: () =>
        yup
          .string()
          .required('Question is required')
          .min(10, 'Question must be at least 10 characters')
          .max(256, 'Question must not exceed 256 characters')
          .test(
            'Checking Custom Question 3 and 1',
            'Question should not be same',
            function (value) {
              return value ? value !== this.parent.customQuestion1 : true;
            },
          )
          .test(
            'Checking Custom Question 3 and 2',
            'Question should not be same',
            function (value) {
              return value ? value !== this.parent.customQuestion2 : true;
            },
          ),
    }),
  });

  const handleQuestionValChange = (option, index) => {
    const newQuestionVals = selectedQuestionValues;
    newQuestionVals[index] = option;
    setSelectedQuestionValues([...newQuestionVals]);
    setIsButtonDisable(false);
  };

  const handleInput = (e, setFieldValue, handleChange) => {
    handleChange(e);
    setUserData({ ...userData, [e.currentTarget.name]: e.currentTarget.value });
    setFieldValue(e.currentTarget.name, e.currentTarget.value);
    //if(e.currentTarget.name === 'contactNumber') {
    //setFormData( {...formData, contactNumber: e.currentTarget.value.replaceAll(/-/g,"")} );
    //}
  };

  const handleFormData = (keyName, val) => {
    setUserData({ ...userData, [keyName]: val });
  };

  const saveSecurityQuestions = async (securityQuestionsPayload) => {
    try {
      const response = await axiosInstance.post(
        APIEndpoints.postSecurityQuestions(),
        securityQuestionsPayload,
      );
      if (
        response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200 ||
        response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_201
      ) {
        return new Promise((resolve, reject) => {
          resolve('Success!');
        });
      } else {
        return new Promise((resolve, reject) => {
          reject(
            'We are unable to update security questions. Please try again!',
          );
        });
      }
    } catch (e) {
      return new Promise((resolve, reject) => {
        reject(e);
      });
    }
  };

  const handleSecurityQuestionsError = (isError) => {
    console.log('handleSecurityQuestionsError :::::', isError);
    setSecuritysQuestionsError(isError);
  };

  const handleSave = async () => {
    if (userData.securityQuestionDetails) {
      const {
        question1,
        question2,
        question3,
        answer1,
        answer2,
        answer3,
        customQuestion1,
        customQuestion2,
        customQuestion3,
      } = userData.securityQuestionDetails;

      const securityQuestionsPayload = {
        SecurityQuestions: [
          {
            oid:
              question1['value'] === 'Others'
                ? userData.othersOid
                : question1['value'],
            securityquestion: customQuestion1
              ? customQuestion1
              : question1['label'],
            answer: answer1,
            custom: question1 && question1['value'] === 'Others' ? true : false,
          },
          {
            oid:
              question2['value'] === 'Others'
                ? userData.othersOid
                : question2['value'],
            securityquestion: customQuestion2
              ? customQuestion2
              : question2['label'],
            answer: answer2,
            custom: question2['value'] === 'Others' ? true : false,
          },
          {
            oid:
              question3['value'] === 'Others'
                ? userData.othersOid
                : question3['value'],
            securityquestion: customQuestion3
              ? customQuestion3
              : question3['label'],
            answer: answer3,
            custom: question3['value'] === 'Others' ? true : false,
          },
        ],
        UserID: userData.email,
      };
      saveSecurityQuestions(securityQuestionsPayload)
        .then(() => {
          toast.success(
            <ToastMessage
              type="success"
              subTitle="Security questions and answers are saved successfully."
            />,
          );
          setTimeout(() => {
            dispatch(setHasSecurityQuestions(true));
            navigate('/admin/admin-dashboard');
          }, 1500);
          console.log('Questions Saved:::::::::::::::');
        })
        .catch((error) => {
          //toast.error( <ErrorMessage message={error?.response?.data?.message} /> );
          setSaveSecurityQAError(true);
        });
    }
  };

  useEffect(() => {
    if (userData.securityQuestionDetails) {
      handleSave();
    }
  }, [userData.securityQuestionDetails]);

  if (!isLoggedIn) {
    return <Navigate to="/admin" push={true}></Navigate>;
  }

  const redirectToDashboard = () => {
    dispatch(setHasSecurityQuestions(true));
    navigate('/admin/admin-dashboard');
  };

  return (
    <Container>
      <Row className="mb-4">
        <Col className="p-0">
          <div className="page-header d-flex align-items-center">
            <h1 className="register-header mb-2">Setup Security Questions</h1>
          </div>
          <HorizontalDivider />
        </Col>
      </Row>
      <Row>
        <Col className="p-0">
          {!securitysQuestionsError ? (
            <SecurityQuestion
              currentStep={3}
              nextStep={handleSave}
              securityQuestionschema={securityQuestionschema}
              handleQuestionValChange={handleQuestionValChange}
              selectedQuestionValues={selectedQuestionValues}
              formData={userData}
              handleInput={handleInput}
              isButtonDisable={isButtonDisable}
              handleFormData={handleFormData}
              isSave={true}
              handleSecurityQuestionsError={handleSecurityQuestionsError}
              subContent="It's important to set up Security Questions if you haven't done so already. These questions play a crucial role in verifying your identity when it comes to recovering your password if it's ever forgotten. Select three security questions from the list below."
              saveSecurityQuestionsError={saveSecurityQAError}
            />
          ) : (
            <CustomClientError
              ErrorHeading="Something went wrong with request!"
              ErrorMessage="Please try again."
              isReDirect={true}
              buttonLabel="GO TO DASHBOARD"
              onClickHandler={redirectToDashboard}
            />
          )}
        </Col>
      </Row>
      <div className="toastify">
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </Container>
  );
};

export default SecurityQuestionsPanel;
